import { getProducts } from "features/hosting/hostingSlice";
import MainLayouts from "layouts/MainLayouts";
import { useEffect } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  getProduct,
  selectProduct,
} from "../../features/common/products/productsSlice";
import { formatIDR, useQuery } from "../../helpers/utils";

const TestingOrder = () => {
  const query = useQuery();
  const dispatch = useDispatch();
  const productSelected = useSelector(selectProduct);
  const { gid: currentGID } = productSelected.current;
  // const productGroup = useSelector((state) => state.hosting.products)

  useEffect(() => {
    if (query.pid) {
      dispatch(getProduct(query.pid));
    }
  }, [query, dispatch]);

  useEffect(() => {
    if (currentGID) {
      dispatch(getProducts(currentGID));
    }
  }, [dispatch, currentGID]);

  return (
    <MainLayouts summary={false}>
      <Container fluid className="mx-0 px-0 overflow-hidden">
        <Row>
          {productSelected.status === "loading" ? (
            <Card.Text>Loading...</Card.Text>
          ) : (
            <Col xs={12} md={12} lg={12}>
              <Card>
                <Card.Body>
                  <h3 className="fw-bold">
                    {productSelected.current?.name ?? "Unknown Products"}
                  </h3>
                  <p className="mb-0">
                    {formatIDR(productSelected.current?.pricing?.IDR.annually)}
                  </p>
                </Card.Body>
              </Card>
            </Col>
          )}
        </Row>
      </Container>
    </MainLayouts>
  );
};

export default TestingOrder;
